import {Component, Inject, Optional} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

/**
 * This is a generic modal used in multiple context to alert the user :
 * - before living editor without saving
 * - before reset notepad content
 */
@Component({
    selector: 'app-notepad-generic-alert-modal',
    templateUrl: './notepad-generic-alert-modal.component.html',
    standalone: false
})
export class NotepadGenericAlertModalComponent {

    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) public modalData: { contentKey: string },
        public selfDialogRef: MatDialogRef<NotepadGenericAlertModalComponent>) {
    }

}